import { AuthService } from '../auth/auth.service';
import { ImageService } from '../cache/image.service';
import { LanguageService } from '../shared/services/language.service';
import { SmwService, StationInfo } from './smw.service';

import { DatexPipe } from '../shared/datex.pipe';
import { KeyPipe } from '../shared/key.pipe';
import { RoundPipe } from '../shared/round.pipe';
import { WindrosePipe } from '../shared/windrose.pipe';
import { ColSpanPipe } from './pipes/col-span.pipe';
import { ColorMappingCondPipe } from './pipes/color-mapping-cond.pipe';
import { ColorMappingTTPipe } from './pipes/color-mapping-tt.pipe';
import { StationIconCardPipe } from './pipes/station-icon-card.pipe';

import { WmIconDirective } from '../shared/wm-icon.directive';

import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  Injector,
  input,
  signal,
  untracked,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { environment } from '../../environments/environment';

import { colSpan } from './constants/constants';
import { isNil } from 'src/utils/utils';

export const MODULES = [
  CommonModule,
  MatCardModule,
  MatTooltipModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent];
export const PIPES = [
  DatexPipe,
  WindrosePipe,
  KeyPipe,
  RoundPipe,
  ColSpanPipe,
  ColorMappingTTPipe,
  ColorMappingCondPipe,
  StationIconCardPipe,
];
export const DIRECTIVES = [WmIconDirective];

@Component({
  selector: 'app-smw-overview-card',
  templateUrl: './smw-overview-card.component.html',
  styleUrls: ['./smw.component.scss'],
  providers: [ImageService],
  imports: [...MODULES, ...COMPONENTS, ...PIPES, ...DIRECTIVES],
})
export class SmwOverviewCardComponent {
  private injector = inject(Injector);
  public smwService = inject(SmwService);
  private imageService = inject(ImageService);
  private auth = inject(AuthService);
  public languageService = inject(LanguageService);

  latestSmwData = input<any>();
  station = input<any>();
  webcamStatus = input<boolean>();
  webcamImage = input<string>();
  stationInfos = input<Array<StationInfo>>();

  stationInfo: StationInfo;
  stationImage = signal<string>(undefined);

  parameterGroups = signal({});

  constructor() {
    this.listenToLatestSmwDataChanges();
    this.listenToStationInfosChanges();
  }

  getStationInfo(): void {
    for (const stationInfo of this.stationInfos()) {
      if (stationInfo.stationId == this.station().stationId) {
        this.stationInfo = stationInfo;
      }
    }
  }

  colSpan(i: number, parameterGroup: string): number {
    return colSpan(i, parameterGroup, this.parameterGroups());
  }

  setStationOnMapImage(): void {
    const url =
      environment.mapbox.url +
      '/styles/v1/' +
      this.smwService.getActiveMapLayer()['style'] +
      '/static/' +
      'pin-m+f74e4e(' +
      this.stationInfo.longitude +
      ',' +
      this.stationInfo.latitude +
      ')/' +
      this.stationInfo.longitude +
      ',' +
      this.stationInfo.latitude +
      ',11/400x300?access_token=' +
      environment.mapbox.accessToken;
    this.imageService.cacheUrls = [url];
    this.imageService.getImage(url).subscribe(
      () => {
        this.stationImage.set(url);
      },
      err => console.error('setStationOnMapImage ' + url, err)
    );
  }

  onWebcamClick() {
    if (this.auth.isZuerichCustomer()) {
      window.open(
        'https://s3.eu-west-1.amazonaws.com/obs.gma.lufft.wm/waiblingen.html',
        '_blank'
      );
    }
  }

  private listenToLatestSmwDataChanges() {
    effect(
      () => {
        const latestSmwData = this.latestSmwData();

        untracked(() => {
          if (isNil(this.stationInfo)) {
            this.parameterGroups.set({
              ...this.smwService.latestParameterGroups(latestSmwData),
            });
          }
        });
      },
      { injector: this.injector }
    );
  }

  private listenToStationInfosChanges() {
    effect(
      () => {
        this.stationInfos();

        if (isNil(this.stationInfo)) {
          untracked(() => {
            this.getStationInfo();
            this.setStationOnMapImage();
          });
        }
      },
      { injector: this.injector }
    );
  }
}
